import { render } from "./TheRechargesV2Ended.vue?vue&type=template&id=663ee4d6"
import script from "./TheRechargesV2Ended.vue?vue&type=script&lang=js"
export * from "./TheRechargesV2Ended.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__